import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { PoolFilters } from '@/types/pool';
import { usePools } from './queries/usePoolQueries';

const DEFAULT_PAGINATION = {
  page: 1,
  page_size: 20,
  total: 0,
  total_pages: 1,
  has_next: false,
  has_previous: false,
};

export function usePoolsPagination(filters: PoolFilters = {}) {
  const [searchParams, setSearchParams] = useSearchParams();

  const page = parseInt(searchParams.get('page') || '1', 10);

  const handlePageChange = useCallback(
    (newPage: number) => {
      setSearchParams({ page: newPage.toString() });
    },
    [setSearchParams]
  );

  const { data, isLoading, ...queryResult } = usePools(page, filters);
  const pagination = data?.pagination ?? DEFAULT_PAGINATION;

  return {
    page,
    pagination,
    handlePageChange,
    pools: data?.pools ?? [],
    isLoading,
    ...queryResult,
  };
}
